// Failbot needs to load first so we get errors from system lite.
import './github/failbot-error'

// Browser polyfills
import 'request-idle-polyfill'
import 'smoothscroll-polyfill'
import 'user-select-contain-polyfill'

import './system-lite'

if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value<Key extends PropertyKey>(object: unknown, property: Key) {
      if (object == null) {
        throw new TypeError('Cannot convert undefined or null to object')
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property)
    },
    configurable: true,
    enumerable: false,
    writable: true
  })
}

/*
  This file polyfills the following: https://github.com/whatwg/dom/issues/911
  Once all targeted browsers support this DOM feature, this polyfill can be deleted.
  This allows users to pass an AbortSignal to a call to addEventListener as part of the
  AddEventListenerOptions object. When the signal is aborted, the event listener is
  removed.

  See: https://github.com/primer/react/blob/798cfc4a2dfadc6cc9a0e3763486b2e5d8c37fa9/src/polyfills/eventListenerSignal.ts
*/

let signalSupported = false
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}
try {
  const options = Object.create(
    {},
    {
      signal: {
        get() {
          signalSupported = true
        }
      }
    }
  )
  window.addEventListener('test', noop, options)
  window.removeEventListener('test', noop, options)
} catch (e) {
  /* */
}

if (!signalSupported) {
  const originalAddEventListener = EventTarget.prototype.addEventListener
  EventTarget.prototype.addEventListener = function (name, originalCallback, optionsOrCapture) {
    if (
      typeof optionsOrCapture === 'object' &&
      'signal' in optionsOrCapture &&
      optionsOrCapture.signal instanceof AbortSignal
    ) {
      if (optionsOrCapture.signal.aborted) return
      originalAddEventListener.call(optionsOrCapture.signal, 'abort', () => {
        this.removeEventListener(name, originalCallback, optionsOrCapture)
      })
    }
    return originalAddEventListener.call(this, name, originalCallback, optionsOrCapture)
  }
}

// Polyfill to add randomUUID when it's not available
if (typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = () => {
    const buf = new Uint32Array(4)
    window.crypto.getRandomValues(buf)
    let idx = -1
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      idx++
      const r = (buf[idx >> 3] >> ((idx % 8) * 4)) & 15
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }
}

declare global {
  interface AddEventListenerOptions {
    signal?: AbortSignal
  }
  interface Object {
    hasOwn: <Key extends PropertyKey>(object: unknown, property: Key) => object is unknown & Record<Key, unknown>
  }
}
